import styled from 'styled-components'

const FONT = "'Inter', ui-sans-serif, system-ui, sans-serif"
const TEXT = '#1a2b3c'
const TEXT_MUTED = '#6b7a8d'
const ACCENT = '#0f8b8d'
const BORDER = '#e3e8ee'

// A compact row of headcount stats so the Census tab reads at a glance.
export const CensusSummary = styled.div`
  font-family: ${FONT};
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
`

export const StatCard = styled.button<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 104px;
  padding: 8px 12px;
  border: 1px solid ${BORDER};
  border-radius: 8px;
  background: #fff;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;

  &:hover {
    border-color: ${ACCENT};
    box-shadow: 0 1px 4px rgba(15, 139, 141, 0.15);
  }

  &:focus-visible {
    outline: 2px solid ${ACCENT};
    outline-offset: 2px;
  }

  ${({ $active }) =>
    $active
      ? `border-color: ${ACCENT};
    background: rgba(15, 139, 141, 0.08);
    box-shadow: 0 1px 6px rgba(15, 139, 141, 0.18);`
      : ''}
`

export const StatValue = styled.span<{ $accent?: boolean }>`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
  color: ${({ $accent }) => ($accent ? ACCENT : TEXT)};
`

export const StatLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${TEXT};
`

export const StatHint = styled.span`
  font-size: 10px;
  font-weight: 400;
  color: ${TEXT_MUTED};
`

export const CensusCaption = styled.p`
  font-family: ${FONT};
  font-size: 11px;
  color: ${TEXT_MUTED};
  margin: 0 0 10px;
  line-height: 1.4;
`
